module.exports = __webpack_public_path__ + "img/little-mac-min.307b60b7.png";